import store from 'store'
import client from './Client'

export default class AbstractClient {
  lastResponse = null

  async get (url, headers = {}) {
    return await this.__doRequest('get', url, {}, headers)
  }

  async post (url, data = {}, headers = {}) {
    return await this.__doRequest('post', url, data, headers)
  }

  async put (url, data = {}, headers = {}) {
    return await this.__doRequest('put', url, data, headers)
  }

  async delete (url, data = {}, headers = {}) {
    return await this.__doRequest('delete', url, data, headers)
  }

  async __doRequest (method, url, data, headers) {
    headers = mergeDefaultHeaders(headers)

    const response = await client.request({ method, url, data, headers })

    this.lastResponse = response

    return response.data
  }
}

function mergeDefaultHeaders (headers) {
  const { token } = store.state.auth
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...headers
  }
}
